import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { mortgageMiniCalculatorApi } from '../api';
import { TType as TPageType } from '../../common/repositories/mortgage-broker-calculator/entities/get_offers_listing_for_newbuiling/GetOffersV1Request';
import { useApplicationContext } from '../../common/utils/applicationContext';
import { IErrorResponse } from '../types';
import { setRedirectUrl } from '../redux';
import { selectEntityId, selectFormDefaults, selectPageType } from '../selectors/calculator';

interface IParams {
  id: number;
  type: TPageType;
  objectCost: number;
  downPayment: number;
  loanTermYears: number;
}

export type IFetchOffersProps = Omit<IParams, 'id' | 'type'>;

export const useGetOffers = () => {
  const dispatch = useDispatch();
  const { logger } = useApplicationContext();
  const defaultParams = useSelector(selectFormDefaults);
  const entityId = useSelector(selectEntityId);
  const pageType = useSelector(selectPageType);

  const initialParams = {
    id: entityId,
    type: pageType,
    ...defaultParams,
  };
  const [params, setParams] = useState<IParams>(initialParams);

  const { data, isFetching, error, refetch } = mortgageMiniCalculatorApi.endpoints.getOffers.useQuery(params);

  if (error) {
    // TODO: заменить обработку ошибок на стандартную, выяснить что для этого нужно
    const typedError = error as IErrorResponse;
    logger.error(
      {
        name: typedError.message || 'Ошибка получения оферов для мини калькулятора',
        message: (typedError.errors && typedError.errors[0].message) || typedError.message || 'Неизвестная ошибка',
      },
      {
        domain: 'Ошибка получения оферов для мини калькулятора: useGetOffers.ts',
      },
    );
  } else if (data) {
    dispatch(setRedirectUrl({ url: data.meta.generalLink }));
  }

  const fetchOffers = (newParams: IFetchOffersProps) => {
    setParams({ ...params, ...newParams });
  };

  return { data, isFetching, error, refetch, fetchOffers };
};
